/**
 * Kalendář API — typed wrapper around `/v1/kalendar/predani` (vehicle
 * handovers). Mirrors `DeliveryListResponseSchema` in
 * `api/src/schemas/kalendar.ts`. Calendar events were retired (0035); the
 * other items on the calendar come from their own modules' endpoints.
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface CalendarDelivery {
  id_smlouvy: number;
  provedeni: string;
  /** The protocol date once handed over (`predano`), else the planned date. */
  datum_predani: string;
  predano?: boolean;
  jmeno_zakaznika: string | null;
  nazev_znacky: string | null;
  nazev_modelu: string | null;
}

interface DeliveryListResponse {
  deliveries: CalendarDelivery[];
  month: number;
  year: number;
}

export function useKalendarPredaniQuery(mesic: number, rok: number) {
  return useQuery({
    queryKey: ['kalendar', 'predani', mesic, rok],
    queryFn: ({ signal }) =>
      api.get<DeliveryListResponse>(`/v1/kalendar/predani?mesic=${mesic}&rok=${rok}`, {
        signal,
      }),
    placeholderData: (previous) => previous,
  });
}
